export default {
	en: {
		label: {
			//Actions
			edit: "Edit",

			//Objects
			rubric: "Rubric",

			//Fields
			name: "Name",
			ref_id: "Ref ID",
			resolution_rule: "Resolution Rule",
			active: "Active",
			actions: "Actions",
			new: {
				item: "New Item"
			},
			search: {
				item: "Search Items..."
			},
			page: {
				//Actual page titles, intended to be displayed in header bar
				Landing: "Landing",
				BulletinBoard: "Bulletin Board",
				Dashboard: "Dashboard",
				SupervisorDashboard: "Supervisor Dashboard",
				ProjectDashboard: "Project Dashboard",
				Profile: "Profile",
				Scoring: "Scoring",
				Backreading: "Backreading",
				Mail: "Mail",
				Viewer: "Viewer",
				ReportCompletion: "Completion",
				ReportScorers: "Scorers",
				ReportDaily: "Daily",
				ReportUserSummary: "User Summary",
				ReportItemSummary: "Item Summary",
				ReportUserAgreement: "User Agreement",
				ReportProjectAgreement: "Project Agreement",
				Burndown: "Burndown",
				Auditing: "Responses",
				ScoreAuditing: "Scores",
				ResetHistory: "Reset History",
				QCSetup: "QC Setup",
				QCSetResponses: "QC Setup",
				QCReport: "QC Reporting",
				QCUserSetReport: "QC Reporting",
				UserSetup: "Users",
				UserEdit: "User Edit",
				TeamSetup: "Teams",
				TeamEdit: "Team Edit",
				TenantSetup: "Tenant Setup",
				TenantEdit: "Tenant Edit",
				ProjectSetup: "Project Setup",
				ProjectEdit: "Project Edit",
				SectionSetup: "Section Setup",
				SectionEdit: "Section Edit",
				ItemSetup: "Item Setup",
				ItemEdit: "Item Edit",
				RubricSetup: "Rubric Setup",
				RubricEdit: "Rubric Edit",

				//Subpages
				//For Item
				item_details: "Item Details",
				scoring_setup: "Scoring Setup",
				viewer_controls: "Viewer Controls",
				resources: "Resources",
				quality_settings: "Quality Settings",
				integrations: "Integrations",
				flag_codes: "Flag Codes"
			},
			location: {
				//A title-esque description of a user's current page/activity
				Login: "Landing", //Yes, Login should map to 'Landing'
				Landing: "Landing",
				BulletinBoard: "Bulletin Board",
				Dashboard: "Dashboard",
				SupervisorDashboard: "Supervisor Dashboard",
				ProjectDashboard: "Project Dashboard",
				Profile: "Profile",
				Scoring: "Scoring Entry",
				Backreading: "Backreading",
				Mail: "Mail",
				Viewer: "Scoring",
				Resolution: "Scoring",
				BackreadViewer: "Scoring",
				QueueBackreadViewer: "Scoring",
				FlagQueueViewer: "Scoring",
				QCTrueScoreViewer: "QC Setup",
				TrainingViewer: "QC",
				RangefindingViewer: "Rangefinding",
				QCUserSetReport: "QC",
				ReportCompletion: "Completion Report",
				ReportScorers: "Scorers Report",
				ReportDaily: "Daily Report",
				ReportUserSummary: "User Summary",
				ReportItemSummary: "Item Summary",
				ReportUserAgreement: "User Agreement Report",
				ReportProjectAgreement: "Project Agreement Report",
				Burndown: "Burndown Report",
				Auditing: "Response Auditing",
				ScoreAuditing: "Score Auditing",
				ResetHistory: "Reset History",
				QCSetup: "QC Setup",
				QCSetResponses: "QC Setup",
				QCReport: "QC Reporting",
				QCUserSetReport: "QC Reporting",
				RFSetup: "Rangefinding Setup",
				RFSetResponses: "Rangefinding Setup",
				RFReport: "Rangefinding Reporting",
				UserSetup: "User Config",
				UserEdit: "User Config",
				TeamSetup: "Team Config",
				TeamEdit: "Team Config",
				TenantSetup: "Tenant Config",
				TenantEdit: "Tenant Config",
				ProjectSetup: "Project Config",
				ProjectEdit: "Project Config",
				SectionSetup: "Section Config",
				SectionEdit: "Section Config",
				ItemSetup: "Item Config",
				ItemEdit: "Item Config",
				RubricSetup: "Rubric Config",
				RubricEdit: "Rubric Config"
			},
			subtask: {
				resolution: "Resolution",
				backreading: "Backreading",
				flag_queue: "Flag Queue",
				training: "Training",
				qc_user_set: "Set Results"
			}
		},
		tooltip: {
			edit: {
				item: "Edit this Item"
			},
			new: {
				item: "Create a new Item"
			},
			delete: {
				item: "Delete this Item"
			}
		}
	},
	ja: {
		label: {
			edit: "編集",

			rubric: "ルーブリック",

			name: "名前",
			ref_id: "商品番号",
			resolution_rule: "解決の規則",
			active: "動作状態",
			actions: "アクション",
			new: {
				item: "新しいアイテム"
			},
			search: {
				item: "Search Items..."
			},
			page: {
				item_setup: "アイテムの設定",

				item_details: "アイテムの詳細",
				scoring_setup: "スコアの設定",
				viewer_controls: "ビューワの操作",
				resources: "資源",
				quality_settings: "精度管理の設定",
				integrations: "統合",
				flag_codes: "フラグの記号"
			}
		},
		tooltip: {
			edit: {
				item: "このアイテムを編集する"
			},
			new: {
				item: "新しいアイテムを作る"
			},
			delete: {
				item: "このアイテムを削る"
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/i18n/lang/messages.js